import { validators } from '@backstagex-vue-form-generator/core';

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '錯誤代碼',
    model: 'error_code',
    required: true,
    disabled: true,
    hint: '此欄位由後端維護',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '顯示文案',
    model: 'message',
  },
  {
    type: 'bsx-textarea',
    inputType: 'textarea',
    label: '使用情境備註說明',
    model: 'note',
    disabled: true,
    hint: '此欄位由後端維護',
  },
];

export default fields;
